<template>
  <div>
    <md-card id="globes" align="Left" style="margin-top: 4rem;">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">language</i>
        </div>
        <h4 class="title">Globes</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0;">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm" @keyup.enter.native="handleSearch"> 
              <label>Search</label>
              <md-input v-model="currentSearchTxt" /> 
            </md-field>
          </div>    
          <div class="md-layout md-gutter md-layout-item md-size-30">
            <md-field>
              <label>Client</label>
              <md-select v-model="currentOrganizationSearch" :disabled="!organizations.length">
                <md-option value="all">
                  All
                </md-option>
                <md-option v-for="item in organizations" :key="item.id" :value="item.id" class="mselect">
                  {{ item.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>    
          <div class="md-layout-item md-size-50" style="align-items: end;">
            <div
              class="md-layout md-gutter md-layout-item"
              style="display: flex; align-items: center; justify-content: right"
            >
              <md-button class="md-icon-button md-primary" @click="handleSearch">
                <md-icon>search</md-icon>
                <md-tooltip md-direction="bottom">Filter Globes</md-tooltip>
              </md-button>
              <md-button class="md-icon-button" @click="handleRefresh">
                <md-icon>refresh</md-icon>
                <md-tooltip md-direction="bottom">Refresh list</md-tooltip>
              </md-button>
              <md-button class="md-icon-button md-primary" @click="openAddModal">
                <md-icon>add</md-icon>
                <md-tooltip md-direction="bottom">Create new Globe</md-tooltip>
              </md-button>
            </div>
          </div>
        </div>
      </md-card-header>

      <md-card-content style="padding-top: 0;">
        <md-table
        id="globes-table"
          v-if="!isLoading"
          v-model="tableData"
          class="table-shopping table-striped table-hover"
        >
          <md-table-row>
            <md-table-empty-state
              :md-description="`No Globes found for this time frame or search criteria`"
              md-label="No Globes found"
            />
          </md-table-row>
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
          >
            <md-table-cell />
            <md-table-cell md-label="Name">{{ item.name || '-' }}</md-table-cell>
            <md-table-cell md-label="Description">{{ item.description || '-' }}</md-table-cell>
            <md-table-cell md-label="Serial No.">{{ item.serialNo || '-' }}</md-table-cell>
            <md-table-cell md-label="Locations Assigned">{{ item.locations.length }}</md-table-cell>
            <md-table-cell>
              <div style="display: flex;justify-content: end;">
                <md-button class="md-icon-button"
                  style="width: 36px; height:27px;display: flex;align-items: center;justify-content: center;"
                  @click.stop="handleEdit(item)">
                  <md-icon>edit</md-icon>
                  <md-tooltip md-direction="bottom">Edit Globe</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-primary"
                  style="width: 36px; height:27px;display: flex;align-items: center;justify-content: center;margin-left: 0.5rem;"
                  @click.stop="globeSelected = item;showGlobeDetailsModal = true">
                  <md-icon>assignment</md-icon>
                  <md-tooltip md-direction="bottom">See details</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-danger"
                  style="width: 36px; height:27px;display: flex;align-items: center;justify-content: center;margin-left: 0.5rem;"
                  @click.stop="handleRemove(item)">
                  <md-icon>delete</md-icon>
                  <md-tooltip md-direction="bottom">Remove Globe configuration</md-tooltip>
                </md-button>
              </div>
            </md-table-cell>

            <md-table-cell />
          </md-table-row>
        </md-table>

        <hr v-if="!isLoading" />
        <div v-if="!isLoading" style="display: flex;align-items: center;">
          <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left" />
            </a>
            <span class="page-link" style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px;">{{ currentPage }}</span>
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right" />
            </a>
          </div>
          <div class="table table-stats" style="display: flex; justify-content:center; align-items:start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b
                ><u>{{ startGlobe }}</u></b
                >
                to
                <b
                ><u>{{ endGlobe }}</u></b
                >. Total of
                <b
                ><u>{{ totalGlobes }}</u></b
                >
                Globes.
              </p>
            </div>
          </div>
          <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages" @change="updateLimit">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog :md-active.sync="showGlobeFormModal">
      <md-dialog-title style="background-color: rgb(11, 108, 141);color: #fff;margin-bottom: 0;padding: 1rem 24px;">
        {{ globeSelected ? 'Update Globe' : 'Create Globe' }}
      </md-dialog-title>
      <md-dialog-content style="margin-top: .5rem;padding: 0 24px;">
        <div>
          <md-field :class="[
            { 'md-valid': !errors.has('name') && touched.name },
            { 'md-form-group': false },
            { 'md-error': errors.has('name') && touched.name }
          ]">
            <label>Name</label>
            <md-input v-validate="'required|max:45'" type="text" name="name" data-vv-name="name" v-model="name"></md-input>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('name')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('name') && touched.name" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>

          <md-field :class="[
            { 'md-valid': !errors.has('description') && touched.description },
            { 'md-form-group': false },
            { 'md-error': errors.has('description') && touched.description }
          ]">
            <label>Description</label>
            <md-input v-validate="'required|max:100'" type="text" name="description" data-vv-name="description" v-model="description"></md-input>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('description')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('description') && touched.description" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>

          <md-field :class="[
            { 'md-valid': !errors.has('serialNo') && touched.serialNo },
            { 'md-form-group': false },
            { 'md-error': errors.has('serialNo') && touched.serialNo }
          ]">
            <label>Serial No.</label>
            <md-input v-validate="'required|max:45'" type="text" name="serialNo" data-vv-name="serialNo" v-model="serialNo"></md-input>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('serialNo')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('serialNo') && touched.serialNo" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </md-dialog-content>

      <md-dialog-actions style="justify-content: center;margin-bottom: 1rem;padding: 0;">
        <md-button :disabled="isSaving" style="width: 100px;background-color: white !important;box-shadow: none;color: #000 !important;" @click="closeGlobeFormModal()">Cancel</md-button>
        <md-button class="md-primary" :disabled="isSaving" style="width: 100px;" @click="handleSaveGlobe()"><span :class="[{'saving': isSaving}]">{{ isSaving ? 'Saving...' : 'Save' }}</span></md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showGlobeDetailsModal" v-if="globeSelected">
      <md-dialog-title style="background-color: rgb(11, 108, 141);color: #fff;margin-bottom: 0;padding: 1rem 24px;">
        Globe details
      </md-dialog-title>
      <md-dialog-content style="margin-top: 1rem;padding: 0 24px;">
        <div>
          <div style="display: flex;justify-content: space-between;">
            <span>Name</span> 
            <span>{{ globeSelected.name || '-' }}</span>
          </div>
          <div style="display: flex;justify-content: space-between;">
            <span>Description</span> 
            <span>{{ globeSelected.description || '-' }}</span> 
          </div>
          <div style="display: flex;justify-content: space-between;">
            <span>Serial No.</span> 
            <span>{{ globeSelected.serialNo || '-' }}</span> 
          </div>
          <div style="margin-top: .5rem;"><span>Clients using this Globe:</span></div>
          <div>
            <md-table
              :value="globeSelected.locations"
              class="table-shopping table-striped table-hover"
              style="margin-bottom: 1rem"
            >
              <md-table-row>
                <md-table-empty-state
                  :md-description="`No locations found for this globe`"
                  md-label="No locations found"
                />
              </md-table-row>
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell />
                <md-table-cell md-label="Client Name">{{ item.orgName || '-' }}</md-table-cell>
                <md-table-cell md-label="Activation Date">{{ item.deviceStartDate ? formattedDate(item.deviceStartDate) || '-' : '-' }}</md-table-cell>
                <md-table-cell md-label="Globe Status">{{ deviceStatusList.length ? deviceStatusObject[item.deviceStatus] || '-' : '' }}</md-table-cell>
                <md-table-cell />
              </md-table-row>
            </md-table>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions style="justify-content: center;margin-bottom: 1rem;padding: 0;">
        <md-button style="width: 100px;" @click="showGlobeDetailsModal = false;globeSelected = null">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <loader :is-visible="isLoading" />
  </div>
</template>

<script>
import moment from "moment"
import loader from "@/components/GlobeChek/loader.vue"
import { SlideYDownTransition } from "vue2-transitions"
import Swal from "sweetalert2"

export default {
  components: {
    loader,
    SlideYDownTransition
  },
  data() {
    return {
      API_SERVICE: process.env.VUE_APP_URL,
      API_ROUTE: "/globes",
      allGlobes: [],
      filteredGlobes: [],
      tableData: [],
      searchQuery: "",
      offset: 0,
      limit: 50,
      currentSearchTxt: '',
      currentOrganizationSearch: 'all',
      pendingGlobesOptions: [
        {
          label: 'All',
          value: 'all'
        },
        {
          label: 'Yes',
          value: 'yes'
        },
        {
          label: 'No',
          value: 'no'
        }
      ],
      pendingGlobesSearch: 'all',
      totalGlobes: 0,
      pagination: {
        perPage: 50,
        perPageOptions: [10, 20, 50, 100, 200]
      },
      isLoading: false,
      touched: {
        name: false,
        serialNo: false,
        description: false,
      },
      organizations: [],
      globeSelected: null,
      showGlobeFormModal: false,
      isSaving: false,
      name: null,
      serialNo: null,
      description: null,
      deviceStatusList: [],
      deviceStatusObject: {},
    }
  },
  computed: {
    // Returns a page from the searched data or the whole data. Search is performed in the watch section below
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.filteredGlobes.length
    },
    startGlobe() {
      return this.offset + 1;
    },
    endGlobe() {
      return Math.min(this.offset + this.limit, this.filteredGlobes.length) || 1;
    },
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit
      this.offset = 0
      this.sliceGlobes();
    }
  },
  methods: {
    openAddModal() {
      this.touched.name = false;
      this.touched.serialNo = false;
      this.touched.description = false;
      this.name = '';
      this.serialNo = '';
      this.description = '';
      this.globeSelected = null
      this.showGlobeFormModal = true;
    },
    async fetchGlobes() {
      this.isLoading = true
      const url = this.API_SERVICE + this.API_ROUTE;
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null

      window.axios
        .get(url, data, config)
        .then(r => r.data)
        .then(globes => {
          this.allGlobes = globes;
          this.handleSearch();
        })
        .catch(function(error) {
          console.error(error)
        }).finally(()=> {
          this.isLoading = false
        });

      this.deviceStatusList = await window.axios.get(`${process.env.VUE_APP_URL}/lookup/lookupmaster/DeviceStatus`, config).then(res => res.data);
      for (const i of this.deviceStatusList) {
        this.deviceStatusObject[i.LookupId] = i.DisplayValue
      }
    },
    async fetchOrganizations() {
      const url = `${this.API_SERVICE}/organisations`;
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null

      window.axios
        .get(url, data, config)
        .then(r => r.data)
        .then(orgs => {
          orgs.sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
          this.organizations = orgs;
        })
        .catch(function(error) {
          console.error(error)
        })
    },
    sliceGlobes() {
      this.tableData = JSON.parse(JSON.stringify(this.filteredGlobes)).slice(this.offset, this.offset + this.limit)
    },
    updateLimit(newLimit) {
      this.offset = 0;
      this.sliceGlobes();
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.sliceGlobes();
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.sliceGlobes();
      }
    },
    formattedDate(date) {
      if (new Date(date).getFullYear() === 1900) return null;
      return new moment(date).format("MM/DD/YYYY")
    },
    handleSearch() {
      const searchFilter = this.currentSearchTxt;
      const currentOrganizationSearch = this.currentOrganizationSearch;
      let response = JSON.parse(JSON.stringify(this.allGlobes)); 
      if (searchFilter) {
        response = response.filter(i => {
          const searchText = ( (i.name || '') + (i.identifier || '') + (i.serialNo || '') ).toLowerCase();
          return searchText.includes(searchFilter.toLowerCase());
        });
      }
      if (currentOrganizationSearch != 'all') {
        response = response.filter(i => !!i.locations.find(x=>x.orgId === currentOrganizationSearch));
      }
      this.filteredGlobes = response;
      this.totalGlobes = response.length;
      this.offset = 0;
      this.sliceGlobes();
    },
    handleEdit(item) {
      this.globeSelected = item;
      this.showGlobeFormModal = true;
      this.name = item.name;
      this.serialNo = item.serialNo;
      this.description = item.description;
    },
    closeGlobeFormModal() {
      this.showGlobeFormModal = false;
      this.globeSelected = null;
    },
    async handleSaveGlobe() {
      this.touched.name = true;
      this.touched.serialNo = true;
      this.touched.description = true;
      const valid = await this.$validator.validateAll();
      if (!valid) return;
      this.isSaving = true;
      try {
        const body = {
          name: this.name,
          serialNo: this.serialNo,
          description: this.description,
          createdBy: sessionStorage.getItem("userID"),
          updatedBy: sessionStorage.getItem("userID")
        }
        if (this.globeSelected) {
          const url = `${this.API_SERVICE}${this.API_ROUTE}/${this.globeSelected.id}`;
          const config = { headers: { "Content-Type": "application/json" } }
          await window.axios.patch(url, body, config).then(r => r.data);
        } else {
          const url = `${this.API_SERVICE}${this.API_ROUTE}`;
          const config = { headers: { "Content-Type": "application/json" } }
          await window.axios.post(url, body, config).then(r => r.data);
        }
      this.fetchGlobes();
      this.closeGlobeFormModal()
      } catch (e) {
        console.log(e);
      } finally {
        this.isSaving = false;
      }
    },
    handleRefresh() {
      this.fetchGlobes();
    },
    async handleRemove(item) {

      const response = await Swal.fire({
        title: "Confirmation",
        text: "Do you want to delete the this Globe?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      })
      if (response.value) {
        try {
          this.isLoading = true;
          const url = `${this.API_SERVICE}${this.API_ROUTE}/${item.id}`;
          await window.axios.delete(url).then(r => r.data);
          this.fetchGlobes();
          Swal.fire({
            title: "Deleted!",
            text: "Globe has been deleted.",
            confirmButtonText: "OK"
          })
        } catch (error) {
          this.isLoading = false;
          Swal.fire({
            title: "Error!",
            text: "Error: " + error,
            confirmButtonText: "Try Again"
          })
        }
      }
    }
  },
  mounted() {
    this.fetchGlobes();
    this.fetchOrganizations();
  },

}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  font-size: 0.85rem;
  height: 38px;
}

.md-table-row {
  color: rgb(0, 6, 97);
}

.md-table-row:hover {
  background-color: #0077ff !important;
  color: white;
}

.table-striped {
  tbody > tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody > tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.md-table-row.md-selected-single {
  font-weight: 400;
  font-size: 0.95rem;
  color: white;
  background-color: #00418b !important;
}

.globe-pending {
  background-color: #f44336 !important;
  color: #fff !important;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination-container span {
  margin: 0 15px;
}

.saving {
  clip-path: inset(0 1ch 0 0);
  animation: l 1s steps(4, jump-none) infinite;
}

@keyframes l {
  to {
    clip-path: inset(0)
  }
}

</style>


